<template>
  <div>
    <br class="hidden-xs-only">
    <div class="kongxi hidden-sm-and-up"></div>
    <el-card shadow="always" :body-style="{ padding: '20px' }">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/news' }">新闻动态</el-breadcrumb-item>
        <el-breadcrumb-item>新闻详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <h2>广东东进有害生物防控技术有限公司<br>
          ----有害生物防制服务能力A级资质评审会顺利召开</h2>
        <img width="100%" :src="img[0]" alt="">
        <p>
          2023年1月7日，广东省有害生物防制协会常务副会长兼秘书长邹钦、办公室主任李艳仪、秘书处邓建锋以及东莞市有害生物防制协会秘书长徐兵兵一行莅临我司进行指导审核工作。
        </p>
        <p>
          审核专家组本着严谨、公正原则，按照评估工作的要求和规范，听取了项目汇报、查阅资料、质疑答辩。充分了解公司的服务和运营情况后，专家组成员深入到公司沙田办公室和港口仓库现场，细致审核办公场所、库房药品、设施设备的管理及使用情况，并对一线人员采用现场模拟操作的方式进行了考核。
        </p>
        <p>
          经过审核专家组初步审核，对我司有害生物防制与消毒服务给予了充分的肯定，同时从完善有害生物安全管理体系、增强技术人员有害生物安全知识培训、规范设备管理等方面提出了一些指导性的整改建议。
        </p>
        <p>
          今天各位评审专家老师的到来，既是对我们工作的全面检验，也是对我们工作的鞭策鼓励，让我们能够认识和改正目前存在的问题，进一步完善公司的质量管理体系。
        </p>
        <p>
          接下来我们全体人员必须全力以赴，积极配合，尊重专家老师们提出的意见和建议，认真聆听，虚心接受，切实将管理体系贯彻到每个工作环节当中，用务实的工作态度、科学的工作方法将管理体系持续、有效地运行下去。
        </p>
        <p>
          感谢各位专家莅临我司进行指导与审查工作，公司本着绿色、健康、环保的理念，将不断追求进步，不断发展，积极汲取经验，弥补不足，促进未来更好的发展。
        </p>
        <el-row :gutter="20">
          <el-col :span="12" :xs="24" :offset="0">
            <img width="100%" :src="img[1]" alt="">
          </el-col>
          <el-col :span="12" :xs="24" :offset="0">
            <img width="100%" :src="img[2]" alt="">
          </el-col>
          <el-col :span="12" :xs="24" :offset="0">
            <img width="100%" :src="img[3]" alt="">
          </el-col>
          <el-col :span="12" :xs="24" :offset="0">
            <img width="100%" :src="img[4]" alt="">
          </el-col>
        </el-row>
      </div>
      <br>
      <br>
      <el-row :gutter="20">
        <el-col :span="12" :xs="24" :offset="0">
          <span>&nbsp;</span>
        </el-col>
        <el-col :span="12" :xs="24" :offset="0" style="text-align: right" class="hidden-xs-only">
          <span style="cursor: pointer; color: #666; font-size: 14px"
            @click="$router.push({name: 'News3'})">东莞首例！两家国企...&nbsp;&nbsp;&nbsp;&nbsp;下一条 &gt;</span>
        </el-col>
        <el-col :span="12" :xs="24" :offset="0" style="text-align: left" class="hidden-xs-only">
          <span style="cursor: pointer; color: #666; font-size: 14px" @click="$router.push({name: 'News5'})">上一条 &gt;
            &nbsp;&nbsp;&nbsp;&nbsp;广东东进有害...</span>
        </el-col>
      </el-row>
      <br>
      <br>
    </el-card>
    <br class="hidden-xs-only">
    <div class="kongxi hidden-sm-and-up"></div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        img: [require('@/assets/pstitle.jpg'), require('@/assets/ps2.jpg'), require('@/assets/ps3.jpg'), require('@/assets/ps4.jpg'), require('@/assets/ps5.jpg')]
      }
    }
  }
</script>

<style lang="scss" scoped>
  .kongxi {
    height: 10px;
  }

  .content {
    width: 90%;
    margin: 0 auto;

    h2 {
      font-family: 黑体, SimHei;
      font-size: 24px;
      margin: 20px 0;
      text-align: center;
    }

    p {
      font-size: 16px;
      margin: 20px 0;
      text-align: justify;
      text-indent: 2em;
      color: #515050;
      font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
    }
  }

  @media screen and (max-width: 768px) {
    .content {
      width: 90%;
      margin: 0 auto;

      h2 {
        font-family: 黑体, SimHei;
        font-size: 24px;
        margin: 20px 0;
        text-align: center;
      }

      p {
        font-size: 16px;
        margin: 20px 0;
        text-align: justify;
        text-indent: 2em;
        color: #515050;
        font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
      }
    }
  }
</style>